import React,{Component} from 'react';
import M from  'materialize-css/dist/js/materialize.min.js';
import 'materialize-css/dist/css/materialize.min.css';

class Delete extends Component{
    componentDidMount(){
        M.Modal.init(this.DeleteModal, {});
    }
    
   
    render(){
        return(
            <>
             <div  ref={Modal => {this.DeleteModal = Modal;}} className="modal col l6" id={this.props && this.props.id}>
             <div className="modal-content">
             <div className="col l12 m6">
            {/* startOf new row */}
             <div className="row">
             <h6>Are You Sure You Want To Delete ?</h6> 
            
            </div>  
            </div>
           
            <div className="modal-footer">
             <button className="modal-close waves-effect waves-green btn-flat right" onClick={this.props.handleDelete} type="submit" name="action" style={{margin:2}} >Yes</button>
            <button className="modal-close waves-effect waves-red btn-flat right" style={{margin:2}}>No</button> 
             </div>
             
            {/* EndOf new row */}
             </div>
             </div>
            </>

        )
    }
}
export default Delete;